import { render } from "./InputSwitchWithLabel.vue?vue&type=template&id=61489e1b"
import script from "./InputSwitchWithLabel.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./InputSwitchWithLabel.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__